(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function scroller() {
    var el = document.querySelector('[data-reveal-scope]') || document.body;
    while (el && el !== document.documentElement) {
      var oy = getComputedStyle(el).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && el.scrollHeight > el.clientHeight + 4) return el;
      el = el.parentElement;
    }
    return null;
  }

  function onScrollOf(target, fn) {
    (target || window).addEventListener('scroll', fn, { passive: true });
  }

  function scrollTopOf(target) {
    return target ? target.scrollTop : window.scrollY;
  }

  function scrollMaxOf(target) {
    return target ? target.scrollHeight - target.clientHeight : document.body.scrollHeight - window.innerHeight;
  }

  function initNav() {
    var flaps = {};
    document.querySelectorAll('[data-flap]').forEach(function (flap) {
      flaps[flap.getAttribute('data-flap')] = flap;
    });

    function closeAll() {
      Object.keys(flaps).forEach(function (k) { flaps[k].style.maxHeight = '0px'; });
      document.querySelectorAll('[data-flaptoggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }

    document.querySelectorAll('[data-flaptoggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var flap = flaps[btn.getAttribute('data-flaptoggle')];
        if (!flap) return;
        var wasOpen = btn.getAttribute('aria-expanded') === 'true';
        closeAll();
        if (!wasOpen) {
          var h = 0;
          Array.prototype.forEach.call(flap.children, function (c) { h += c.offsetHeight; });
          flap.style.maxHeight = Math.min(h, Math.round(window.innerHeight * 0.86)) + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

    var sheet = document.querySelector('[data-sheet]');
    document.querySelectorAll('[data-sheettoggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (sheet) sheet.classList.toggle('is-open');
      });
    });
  }

  function initRail(target) {
    var rail = document.querySelector('[data-rail]');
    if (!rail) return;
    var nums = rail.querySelector('[data-railnums]');
    var head = rail.querySelector('[data-railhead]');
    var read = rail.querySelector('[data-railread]');
    if (!nums && !head) return;
    if (nums && !nums.childElementCount) {
      var html = '';
      for (var i = 1; i < 90; i++) {
        html += '<div style="position:absolute;top:' + (i * 70 - 5) + 'px;left:6px">' + i + '</div>';
      }
      nums.innerHTML = html;
    }
    function paint() {
      var max = scrollMaxOf(target);
      var top = scrollTopOf(target);
      var p = max > 0 ? top / max : 0;
      if (head) head.style.transform = 'translateY(' + p * (window.innerHeight - 26) + 'px)';
      if (read) read.textContent = (top / 70).toFixed(1) + '"';
    }
    paint();
    onScrollOf(target, paint);
    window.addEventListener('resize', paint);
  }

  function initReveal(target) {
    if (reduce) return;
    var scope = document.querySelector('[data-reveal-scope]');
    if (!scope) return;
    var sections = Array.prototype.slice.call(scope.querySelectorAll('[data-sv]'));
    if (!sections.length) return;
    if (!('IntersectionObserver' in window)) return;

    sections.forEach(function (sec) {
      sec.classList.add('sv-hide-soft');
      Array.prototype.forEach.call(sec.children, function (child, i) {
        child.classList.add('sv-hide');
        child.style.animationDelay = Math.min(i * 70, 350) + 'ms';
      });
    });

    function show(sec) {
      sec.classList.add('is-in');
      Array.prototype.forEach.call(sec.children, function (c) { c.classList.add('is-in'); });
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          show(e.target);
          io.unobserve(e.target);
        }
      });
    }, { root: target || null, rootMargin: '0px 0px -6% 0px', threshold: 0 });

    sections.forEach(function (sec) { io.observe(sec); });

    setTimeout(function () {
      sections.forEach(function (sec) {
        if (!sec.classList.contains('is-in')) show(sec);
      });
    }, 3000);
  }

  function initVelocity(target) {
    var tracks = document.querySelectorAll('[data-velocity]');
    if (!tracks.length || reduce) return;
    var last = scrollTopOf(target);
    var idle;
    onScrollOf(target, function () {
      var now = scrollTopOf(target);
      var d = Math.abs(now - last);
      last = now;
      var dur = Math.max(4, 44 - Math.min(d, 90) * 0.44);
      tracks.forEach(function (t) { t.style.animationDuration = dur + 's'; });
      clearTimeout(idle);
      idle = setTimeout(function () {
        tracks.forEach(function (t) { t.style.animationDuration = '44s'; });
      }, 220);
    });
  }

  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach(function (wrap) {
      var tabs = wrap.querySelectorAll('[data-tab]');
      var items = document.querySelectorAll('[data-tabitem]');
      var count = document.querySelector('[data-tabcount]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-tab');
          tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
          var shown = 0;
          items.forEach(function (it) {
            var match = key === 'all' || it.getAttribute('data-tabitem') === key;
            it.style.display = match ? '' : 'none';
            if (match) shown++;
          });
          if (count) count.textContent = shown;
        });
      });
    });
  }

  function initBooking() {
    var flow = document.querySelector('[data-booking]');
    if (!flow) return;
    var steps = Array.prototype.slice.call(flow.querySelectorAll('[data-step]'));
    if (!steps.length) return;
    var rail = document.querySelector('[data-bookfill]');
    var readout = document.querySelector('[data-bookstep]');
    var index = 0;

    function paint() {
      steps.forEach(function (s, i) { s.hidden = i !== index; });
      if (rail) rail.style.height = Math.round((index + 1) / steps.length * 100) + '%';
      if (readout) readout.textContent = '0' + (index + 1);
      flow.querySelectorAll('[data-summary]').forEach(function (el) {
        var name = el.getAttribute('data-summary');
        var checked = flow.querySelector('[name="' + name + '"]:checked');
        el.textContent = checked ? checked.value : '—';
      });
    }

    /* A step with radio options cannot be left until one is chosen, or the
       browser refuses to submit a hidden required field at the end. */
    function stepComplete(step) {
      var radios = step.querySelectorAll('input[type="radio"][required]');
      if (!radios.length) return true;
      var name = radios[0].name;
      return !!flow.querySelector('[name="' + name + '"]:checked');
    }

    function warn(step) {
      var note = step.querySelector('[data-stepwarn]');
      if (!note) {
        note = document.createElement('p');
        note.setAttribute('data-stepwarn', '');
        note.className = 's-label s-label--rust';
        note.style.marginTop = '14px';
        note.textContent = 'Pick one to carry on.';
        var nav = step.querySelector('.bk-nav');
        if (nav) nav.parentNode.insertBefore(note, nav.nextSibling);
        else step.appendChild(note);
      }
      note.hidden = false;
    }

    flow.addEventListener('change', function () {
      var note = steps[index].querySelector('[data-stepwarn]');
      if (note) note.hidden = true;
      paint();
    });

    flow.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-option]');
      if (opt && opt.parentElement) {
        opt.parentElement.querySelectorAll('[data-option]').forEach(function (o) {
          o.setAttribute('aria-selected', o === opt ? 'true' : 'false');
        });
      }
      if (e.target.closest('[data-next]')) {
        if (!stepComplete(steps[index])) {
          warn(steps[index]);
          return;
        }
        index = Math.min(index + 1, steps.length - 1);
        paint();
      }
      if (e.target.closest('[data-back]')) {
        index = Math.max(index - 1, 0);
        paint();
      }
    });

    paint();
  }

  ready(function () {
    var target = scroller();
    initNav();
    initRail(target);
    initReveal(target);
    initVelocity(target);
    initTabs();
    initBooking();
  });
})();
